import { FunctionComponent } from "react";
import { GenericIcon } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";
import { MarketIconName } from "@ppb/the-wall-icons";

import styles from "./BlurbBar.web.css";

type BlurbBarViewModel = {
  text?: string;
  hasRulesIcon?: boolean;
};

export const BlurbBar: FunctionComponent<BlurbBarViewModel> = ({ text, hasRulesIcon }) => (
  <div className={styles.blurbBar}>
    {(!!text || !!hasRulesIcon) && (
      <div className={styles.row}>
        {!!hasRulesIcon && (
          <span className={styles.icon}>
            <GenericIcon name={MarketIconName.MARKET_RULES} />
          </span>
        )}
        {!!text && <span className={styles.text}>{text}</span>}
      </div>
    )}
  </div>
);
